"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDisabledRows = void 0;
const react_1 = require("react");
/**
 * Hook to merge row disabling logic with custom cell/row behavior callbacks.
 *
 * When a row is disabled:
 * - Cells cannot be edited (isCellEditable returns false)
 * - Row cannot be selected (isRowSelectable returns false)
 * - Row gets 'Mui-disabled-row' className for styling
 *
 * Custom callbacks are still respected - the hook merges them with the disabling logic.
 */
const useDisabledRows = ({ isRowDisabled, isCellEditable, isRowSelectable, getRowClassName, }) => {
    // Merge isRowDisabled logic with custom isCellEditable if provided
    const mergedIsCellEditable = (0, react_1.useCallback)((params) => {
        if (isRowDisabled === null || isRowDisabled === void 0 ? void 0 : isRowDisabled(params.row)) {
            return false;
        }
        return isCellEditable ? isCellEditable(params) : true;
    }, [isRowDisabled, isCellEditable]);
    // Merge isRowDisabled logic with custom isRowSelectable if provided
    const mergedIsRowSelectable = (0, react_1.useCallback)((params) => {
        if (isRowDisabled === null || isRowDisabled === void 0 ? void 0 : isRowDisabled(params.row)) {
            return false;
        }
        return isRowSelectable ? isRowSelectable(params) : true;
    }, [isRowDisabled, isRowSelectable]);
    // Merge isRowDisabled styling with custom getRowClassName if provided
    const mergedGetRowClassName = (0, react_1.useCallback)((params) => {
        const customClassName = getRowClassName ? getRowClassName(params) : '';
        const disabledClassName = (isRowDisabled === null || isRowDisabled === void 0 ? void 0 : isRowDisabled(params.row)) ? 'Mui-disabled-row' : '';
        return `${customClassName} ${disabledClassName}`.trim();
    }, [isRowDisabled, getRowClassName]);
    return {
        isCellEditable: mergedIsCellEditable,
        isRowSelectable: mergedIsRowSelectable,
        getRowClassName: mergedGetRowClassName,
    };
};
exports.useDisabledRows = useDisabledRows;
